import { isEmpty } from 'lodash';

import { ActionId } from 'admin/actions/Actions';
import { FeatureFlagId } from 'admin/feature-flags/FeatureFlags';
import { ModuleId } from 'admin/modules/Modules';
import { hasModule } from 'admin/tenants/Tenants';
import { isAuthorized } from 'auth/Auth';

export const isVobEnabled = (tenant?: any, profile?: any): boolean => {
    const vobEnabled =
        hasModule(tenant, ModuleId.AnalyticVoiceOfBrand) &&
        isAuthorized({
            actions: [ActionId.AnalyticVOBReviewResponding.View],
        }) &&
        (isEmpty(profile?.featureFlags) ||
            isAuthorized({
                featureFlags: [FeatureFlagId.ReviewYetiDataFetcher],
            }));

    return vobEnabled;
};
